module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/ko/5-859dc5dfa21ac1895ed6d3127fbe602b.jpg";